import React, { useState, useEffect, useContext } from "react";
import { FirebaseContext } from "../../../context/Firebase";
import { DataContext } from "../../../context/Data";
import Mailchimp from "./Mailchimp";
import RedChirp from "./RedChirp";
import Klaviyo from "./Klaviyo";
import CampaignMonitor from "./CampaignMonitor";
// import Scraping from "./Scraping";

const APIAdministration = () => {
  const { functions } = useContext(FirebaseContext);
  const { account } = useContext(DataContext);
  const [activeTab, setActiveTab] = useState("mailchimp");
  const [credentialsData, setCredentialsData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to load credentials (can be called by child components after save)
  const loadCredentials = async () => {
    setLoading(true);
    try {
      const result = await functions.onboarding("account/get/credentials", { account_eid: account });
      console.log("Credentials result:", result);
      if (result.data.success) {
        setCredentialsData(result.data.credentials);
      }
    } catch (error) {
      console.error("Error loading credentials:", error);
    } finally {
      setLoading(false);
    }
  };

  // Load credentials once when component mounts
  useEffect(() => {
    if (account) {
      loadCredentials();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  const tabs = [
    { id: "mailchimp", label: "Mailchimp" },
    { id: "redchirp", label: "RedChirp" },
    { id: "klaviyo", label: "Klaviyo" },
    { id: "campaignmonitor", label: "Campaign Monitor" },
    // { id: "scraping", label: "Tock" },
  ];

  return (
    <div className="w-full h-full flex flex-col bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-6">
        <h1 className="text-3xl font-bold text-gray-900">Campaign Integration</h1>
        <p className="text-sm text-gray-600 mt-2">Manage your advertising platform credentials and integrations</p>
      </div>

      {/* Tabs Navigation */}
      <div className="bg-white border-b border-gray-200 px-6 shadow-sm">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                relative whitespace-nowrap py-4 px-1 font-medium text-sm transition-colors
                ${activeTab === tab.id ? "text-blue-600" : "text-gray-500 hover:text-gray-700"}
              `}
            >
              {tab.label}
              {/* Active tab indicator */}
              {activeTab === tab.id && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-t-full"></span>
              )}
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-4xl mx-auto">
          <>
            {activeTab === "mailchimp" && (
              <Mailchimp credentialsData={credentialsData} onCredentialsSaved={loadCredentials} />
            )}
            {activeTab === "redchirp" && (
              <RedChirp credentialsData={credentialsData} onCredentialsSaved={loadCredentials} />
            )}
            {activeTab === "klaviyo" && (
              <Klaviyo credentialsData={credentialsData} onCredentialsSaved={loadCredentials} />
            )}
            {activeTab === "campaignmonitor" && (
              <CampaignMonitor credentialsData={credentialsData} onCredentialsSaved={loadCredentials} />
            )}
            {/* {activeTab === "scraping" && (
              <Scraping credentialsData={credentialsData?.scraping} onCredentialsSaved={loadCredentials} />
            )} */}
          </>
        </div>
      </div>
    </div>
  );
};

export default APIAdministration;
